import { Link } from "react-router-dom";

const stats = [
  { value: "5000+", label: "影视条目", icon: "ri-movie-2-line" },
  { value: "1080P", label: "高清画质", icon: "ri-hd-line" },
  { value: "全免费", label: "无需付费", icon: "ri-gift-line" },
  { value: "0 广告", label: "清爽体验", icon: "ri-shield-check-line" },
];

export default function SiteIntro() {
  return (
    <section className="px-4 md:px-8 py-10 md:py-16 bg-background-100/60">
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 md:gap-12 items-center">
        <div>
          <span className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-primary-500/15 border border-primary-500/40 text-primary-300 text-xs md:text-sm font-medium mb-4">
            <i className="ri-information-line" /> 关于平台
          </span>
          <h2 className="font-heading font-bold text-2xl md:text-3xl text-foreground-950 leading-snug">
            以内容为核心的高清视频浏览平台
          </h2>
          <p className="mt-4 text-sm md:text-base text-foreground-600 leading-relaxed">
            在线播放汇集电影、电视剧、综艺三大内容板块，用清晰的分类、灵活的筛选和便捷的搜索，帮助每一位观众快速找到想看的内容。
            我们坚持轻量化浏览体验，无需注册、没有繁琐步骤，打开即看。
          </p>
          <p className="mt-3 text-sm md:text-base text-foreground-600 leading-relaxed">
            本站为演示项目，全部内容均为虚构示例，不提供真实播放、下载或付费服务，播放按钮仅作功能展示。
          </p>
          <div className="flex flex-wrap items-center gap-3 mt-7">
            <Link
              to="/category/tv"
              className="inline-flex items-center gap-2 px-5 py-2.5 rounded-md font-medium whitespace-nowrap bg-primary-500 text-background-50 hover:bg-primary-600 transition-colors cursor-pointer"
            >
              开始浏览 <i className="ri-arrow-right-line" />
            </Link>
            <Link
              to="/about"
              className="inline-flex items-center gap-2 px-5 py-2.5 rounded-md font-medium whitespace-nowrap bg-background-200/80 text-foreground-950 hover:bg-background-200 transition-colors cursor-pointer"
            >
              了解更多
            </Link>
          </div>
        </div>

        <div className="grid grid-cols-2 gap-4">
          {stats.map((s) => (
            <div
              key={s.label}
              className="p-5 md:p-6 rounded-lg bg-background-50 border border-background-300/50"
            >
              <span className="w-11 h-11 rounded-lg bg-accent-500/15 text-accent-400 flex items-center justify-center">
                <i className={`${s.icon} text-2xl`} />
              </span>
              <p className="mt-4 font-heading font-extrabold text-2xl text-foreground-950">{s.value}</p>
              <p className="mt-1 text-sm text-foreground-600">{s.label}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}